import(/* webpackMode: "eager" */ "/app/app/(public)/forgot-password/ui/RecoveryForm.js");
import(/* webpackMode: "eager" */ "/app/assets/images/Log_in_hero.webp");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")